import { graphql, useStaticQuery } from "gatsby"

type PageType = "plp" | "pdp" | "cart"

export const useLowStockThreshold = (quantityAvailable?: number | null, page: PageType = "pdp") => {
  const { lowStockSettings: setting } = useStaticQuery<GatsbyTypes.SettingLowStockThresholdQuery>(graphql`
    query SettingLowStockThreshold {
      lowStockSettings: sanitySettingLowStock {
        settingEnableLowStockMessagePLP
        settingEnableLowStockMessagePDP
        settingEnableLowStockMessageCart
        settingVeryLowStockThreshold
        settingLowStockThreshold
        settingVeryLowStockMessage
        settingLowStockMessageText
        settingLowStockMessageColour {
          ...NewPresetColorFragment
        }
      }
    }
  `)

  const qty = quantityAvailable ?? 0

  const isEnabled =
    (page === "plp" && setting?.settingEnableLowStockMessagePLP) ||
    (page === "pdp" && setting?.settingEnableLowStockMessagePDP) ||
    (page === "cart" && setting?.settingEnableLowStockMessageCart)

  const isVeryLowStock =
    isEnabled && qty > 0 && setting?.settingVeryLowStockThreshold != null && qty <= setting.settingVeryLowStockThreshold

  const isLowStock =
    isEnabled &&
    setting?.settingLowStockThreshold != null &&
    qty > (setting?.settingVeryLowStockThreshold ?? 0) &&
    qty <= setting.settingLowStockThreshold

  const showLowStockMessage = isVeryLowStock || isLowStock

  // choose correct message
  let message: string | null = null

  if (isVeryLowStock) {
    message = setting?.settingVeryLowStockMessage?.replace("{stock}", qty.toString()) ?? null
  } else if (isLowStock) {
    message = setting?.settingLowStockMessageText ?? null
  }

  const lowStockSettings = {
    settingLowStockMessageText: message,
    settingLowStockMessageColour: setting?.settingLowStockMessageColour,
  }

  return {
    lowStockSettings,
    showLowStockMessage,
  }
}
